<script lang="ts">
	import { Search } from 'lucide-svelte';

	import * as Command from '$lib/components/ui/command';
	import * as Sidebar from '$lib/components/ui/sidebar';

	import * as m from '$lib/paraglide/messages';

	import CommandBarRegistrations from './command-bar-registrations.svelte';
	import { commandBar } from './command-bar-state.svelte';

	let open = $state(false);
	let keylock = $state(false);

	function handleKeydown(e: KeyboardEvent) {
		if (!keylock && e.key === 'k' && (e.metaKey || e.ctrlKey)) {
			e.preventDefault();
			open = !open;
			keylock = true;
		}
	}

	function handleKeyup(e: KeyboardEvent) {
		if (e.key === 'k') {
			keylock = false;
		}
	}

	const groups = $derived(
		[...commandBar.groups.entries()]
			.map(([groupKey, group]) => {
				const commands = [...group.commands.entries()]
					.map(([commandKey, command]) => ({
						key: commandKey,
						...command
					}))
					.toSorted((a, b) => a.title.localeCompare(b.title));
				return {
					key: groupKey,
					...group,
					commands
				};
			})
			.toSorted((a, b) => a.title.localeCompare(b.title))
	);
</script>

<svelte:document onkeydown={handleKeydown} onkeyup={handleKeyup} />

<CommandBarRegistrations />

<Sidebar.Group>
	<Sidebar.GroupContent>
		<Sidebar.Menu>
			<Sidebar.MenuItem>
				<Sidebar.MenuButton onclick={() => (open = true)} variant="ghost">
					<Search class="stroke-muted-foreground" />
					<span class="text-muted-foreground">{m.searchPlaceholder()}</span>
					<kbd
						class="hidden tracking-widest sm:inline-flex ml-auto bg-muted text-muted-foreground pointer-events-none h-5 select-none items-center gap-1.5 rounded border px-1.5 font-mono text-xs font-medium opacity-100 border-border/20"
					>
						⌘+K
					</kbd>
				</Sidebar.MenuButton>
			</Sidebar.MenuItem>
		</Sidebar.Menu>
	</Sidebar.GroupContent>
</Sidebar.Group>

<Command.Dialog bind:open>
	<Command.Input placeholder="Type a command or search..." />

	<Command.List>
		<Command.Empty>No results found.</Command.Empty>

		{#each groups as group, i (group.key)}
			{#if i > 0}
				<Command.Separator />
			{/if}

			<Command.Group heading={group.title}>
				{#each group.commands as command (command.key)}
					{@const Icon = command.icon}
					<Command.Item
						onSelect={() => {
							command.onSelect();
							open = false;
						}}
					>
						<Icon class="mr-2 size-4" />

						<span>{command.title}</span>

						{#if command.keywords?.length}
							{@const s = command.keywords.join(', ')}
							<span class="hidden">
								{s}
							</span>
						{/if}

						{#if command.shortcut}
							{@const s = command.shortcut.join('+')}
							<Command.Shortcut>{s}</Command.Shortcut>
						{/if}
					</Command.Item>
				{/each}
			</Command.Group>
		{/each}
	</Command.List>
</Command.Dialog>
